import React from 'react'
import clsx from 'clsx'

import OverflowTooltip from '../../../atoms/OverflowTooltip'

import useBaseStyles from '../styles'
import useStyles from './styles'

type TableInputProps = {
  disabled?: boolean
  canEdit?: boolean
  timelineMode?: boolean
  task?: boolean
  inputOnly?: boolean
  field: LocalCustomField
  inTable?: boolean
}

const TableInput: React.FC<TableInputProps> = ({
  disabled,
  canEdit,
  timelineMode,
  task,
  inputOnly,
  field,
  inTable
}) => {
  const baseClasses = useBaseStyles({
    readOnly: disabled,
    canEdit,
    dateTimelineMode: timelineMode,
    task,
    inputOnly,
    inTable
  })
  const classes = useStyles()

  return (
    <div
      className={clsx(
        baseClasses.fieldInputRoot,
        classes.root,
        'cf-input-root'
      )}
    >
      {!inputOnly && (
        <OverflowTooltip
          text={field.description}
          className={clsx(baseClasses.label, 'label')}
        >
          {field.title}
        </OverflowTooltip>
      )}

      <div style={{ width: '100%' }}>TABLE</div>
    </div>
  )
}

export default TableInput
